<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-card
            color="white"
            dark
            elevation="24"
            class="rounded-xl"
            style="padding: 2em"
          >
            <v-card-title
              class="text-h4 font-weight-lighter"
              style="justify-content: center; color: grey"
            >
              <v-icon color="grey" left large>
                mdi-application-edit-outline
              </v-icon>
              Modifier une offre d'emploi
            </v-card-title>
            <v-card-text></v-card-text>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-btn
                  elevation="24"
                  small
                  rounded
                  color="primary"
                  to="/company/offers"
                >
                  <v-icon left> mdi-arrow-left-thin</v-icon>
                  Revenir à la liste de mes offres
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-form>
                  <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
                    <v-snackbar
                      v-model="snackbarFailed"
                      rounded="pill"
                      elevation="24"
                      color="red darken-3"
                      width="100%"
                    >
                      <span class="text-subtitle-1">
                        {{ snackbarFailedMessage.split(":")[1] }}
                        {{ snackbarFailedMessage1 }}
                      </span>
                      <template v-slot:action="{ attrs }">
                        <v-btn
                          color="black"
                          text
                          v-bind="attrs"
                          @click="snackbarFailed = false"
                        >
                          Fermer
                        </v-btn>
                      </template>
                    </v-snackbar>

                    <v-alert
                      outlined
                      type="error"
                      prominent
                      border="left"
                      style="margin-top: 1em"
                      v-if="formErrors.length > 0"
                    >
                      <b>Veuillez corriger les erreurs suivantes:</b>
                      <ul>
                        <li v-for="(error, index) in formErrors" :key="index">
                          • {{ error }}
                        </li>
                      </ul>
                    </v-alert>

                    <v-card color="white" dark class="rounded-xl">
                      <v-card-text>
                        <section
                          style="
                            background: rgba(255, 255, 255, 0.9);
                            color: #777171;
                            padding: 1em;
                          "
                        >
                          <v-row class="pa-5">
                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-autocomplete
                                label="Type d'offre"
                                v-model="jobType"
                                prepend-inner-icon="mdi-format-list-bulleted-type"
                                light
                                item-text="name"
                                item-value="id"
                                required
                                chips
                                :items="jobOfferTypeItems"
                              ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-combobox
                                label="Poste à recruter"
                                id="job"
                                v-model="formFields.job"
                                item-text="name"
                                item-value="id"
                                :items="jobItems"
                                prepend-inner-icon="mdi-account-search-outline"
                                light
                                required
                                chips
                                v-on:change="checkJobValue"
                              ></v-combobox>
                            </v-col>

                            <v-col
                              v-if="displayActivitySector"
                              cols="12"
                              md="6"
                              style="margin-top: -2em"
                            >
                              <v-autocomplete
                                label="Secteur d'activité du poste"
                                v-model="formFields.activitySector"
                                prepend-inner-icon="mdi-table-account"
                                light
                                item-text="name"
                                item-value="id"
                                required
                                chips
                                :items="activitySectorItems"
                              ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-text-field
                                label="Lieu de travail"
                                v-model="formFields.jobLocation"
                                required
                                placeholder="Kaloum"
                                prepend-inner-icon="mdi-map-marker-radius-outline"
                                light
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-text-field
                                label="Rémunération mensuelle (en GNF)"
                                v-model="formFields.remuneration"
                                placeholder="Exemple : 5 000 000 ou Selon le profil"
                                prepend-inner-icon="mdi-cash-multiple"
                                light
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="formFields.startDate"
                                    label="Date de démarrage"
                                    light
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="formFields.startDate"
                                  :active-picker.sync="activePicker"
                                  :min="startDateMin"
                                  @change="save"
                                  locale="fr-fr"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>

                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-checkbox
                                v-model="formFields.coverLetterIsRequired"
                                light
                                color="info"
                                hide-details
                                label="Rendre la lettre de motivation obligatoire"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="formFields.offerExpirationDate"
                                    label="Date d'expiration de l'offre"
                                    light
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="formFields.offerExpirationDate"
                                  :active-picker.sync="
                                    activeOfferExpirationPicker
                                  "
                                  :min="expirationDateMin"
                                  @change="save1"
                                  locale="fr-fr"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="6" style="margin-top: -2em">
                              <v-text-field
                                v-model="formFields.duration"
                                light
                                color="info"
                                placeholder="12 mois"
                                hide-details
                                label="Durée"
                                prepend-inner-icon="mdi-timetable"
                                v-if="displayDurationAndExpiration"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row class="pa-5">
                            <h5>
                              <v-icon left color="black"
                                >mdi-script-text-outline</v-icon
                              >
                              Description de l'offre
                            </h5>
                            <v-col cols="12">
                              <editor
                                api-key="tengbryysq97t0kqjj6qhj25ssgheorm0nv6m0vf8aev6s9z"
                                v-model="formFields.description"
                                :init="{
                                  height: 400,
                                  menubar: true,
                                  language: 'fr_FR',
                                  plugins: [
                                    'advlist autolink lists link image charmap print preview anchor',
                                    'searchreplace visualblocks code fullscreen',
                                    'insertdatetime media table paste code help wordcount',
                                  ],
                                  toolbar:
                                    'undo redo | formatselect | bold italic backcolor | \
                                 alignleft aligncenter alignright alignjustify | \
                                 bullist numlist outdent indent | removeformat | help',
                                }"
                              />
                            </v-col>
                          </v-row>
                        </section>
                      </v-card-text>
                    </v-card>
                    <v-row class="mt-6">
                      <v-col cols="12" offset-md="4" md="4" sm="12" xs="12">
                        <v-btn
                          class="col-12"
                          color="success"
                          rounded
                          v-on:click="editJobOffer"
                        >
                          <v-icon left> mdi-content-save-all-outline</v-icon>
                          Enregistrer
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import Editor from "@tinymce/tinymce-vue";
import Vue from "vue";

export default Vue.extend({
  name: "CompanyEditOffer",
  components: { Editor },
  data: function () {
    return {
      companyInfosIsUpdated: false,
      snackbarFailed: false,
      snackbarFailedMessage: "",
      snackbarFailedMessage1: "",
      jobType: null,
      formFields: {
        startDate: null,
        offerExpirationDate: null,
        job: null,
        jobLocation: null,
        remuneration: null,
        coverLetterIsRequired: true,
        description: null,
        duration: null,
        activitySector: null,
      },
      startDateMin: null,
      expirationDateMin: null,
      currentYear: "" + new Date().getFullYear(),
      jobOfferTypeItems: [],
      jobOfferTypeList: [],
      activitySectorItems: [],
      activitySectorList: [],
      jobItems: [],
      jobList: [],
      displayActivitySector: false,
      currentUser: null,
      companyActivitySector: null,
      companyInformations: null,
      menu: false,
      menu1: false,
      activePicker: null,
      activeOfferExpirationPicker: null,
      show1: false,
      formErrors: [],
      currentJobOffer: null,
      displayDurationAndExpiration: true,
    };
  },
  created() {
    const httpClient = new HttpClient();

    httpClient
      .fetchFromApiPlatformUri(
        "/api/job_offers/" +
          parseInt(this.$route.params.offerId) +
          "?filter[isDeleted]=false",
        localStorage.getItem("jwt-token")
      )
      .then((value) => {
        this.currentJobOffer = value.data;
        console.log(this.currentJobOffer);
        this.jobType = this.currentJobOffer.type["@id"];
        this.formFields.startDate =
          this.currentJobOffer.startDate === null
            ? null
            : this.currentJobOffer.startDate.toLocaleString().split("T")[0];
        this.formFields.job = {
          id: this.currentJobOffer.job["@id"],
          name: this.currentJobOffer.job.name,
        };
        this.formFields.jobLocation = this.currentJobOffer.jobLocation;
        this.formFields.remuneration = this.currentJobOffer.remuneration;
        this.formFields.coverLetterIsRequired =
          this.currentJobOffer.coverLetter;
        this.formFields.description = this.currentJobOffer.description;
        this.formFields.duration = this.currentJobOffer.duration;
        this.formFields.offerExpirationDate =
          this.currentJobOffer.offerExpirationTime;

        if (
          this.currentJobOffer.type.name ===
          "Contrat à durée indéterminée (CDI)"
        ) {
          this.displayDurationAndExpiration = false;
          this.formFields.duration = null;
          this.formFields.offerExpirationDate = null;
        } else {
          this.displayDurationAndExpiration = true;
        }
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        } else if (
          reason.response.status === 404 ||
          reason.response.status === 403
        ) {
          this.$router.push({
            name: "not_found",
          });
        }
        this.formErrors.push(reason);
        console.error(reason);
      });

    // load offer type
    httpClient
      .getJobOffersType(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.jobOfferTypeList = value.data["hydra:member"];
        this.jobOfferTypeList.forEach((elt) => {
          this.jobOfferTypeItems.push({
            id: elt["@id"],
            name: elt["name"],
          });
        });
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        }
        this.formErrors.push(reason);
        console.error(reason);
      });

    // load job
    httpClient
      .getJobs(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.jobList = value.data["hydra:member"];
        this.jobList.forEach((elt) => {
          this.jobItems.push({
            id: elt["@id"],
            name: elt["name"],
          });
        });
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        }
        this.formErrors.push(reason);
        console.error(reason);
      });

    // set min date
    const currentDate = new Date();
    this.startDateMin = `${currentDate.getFullYear()}-${(
      "0" +
      (currentDate.getMonth() + 1)
    ).slice(-2)}-${("0" + (currentDate.getDate() + 1)).slice(-2)}`;
    this.expirationDateMin = `${currentDate.getFullYear()}-${(
      "0" +
      (currentDate.getMonth() + 1)
    ).slice(-2)}-${("0" + (currentDate.getDate() + 7)).slice(-2)}`;

    // load activity sectors
    httpClient
      .fetchFromApiPlatformUri(
        "/api/activity_sectors?filter[isDeleted]=false",
        localStorage.getItem("jwt-token")
      )
      .then((value) => {
        this.activitySectorList = value.data["hydra:member"];
        this.activitySectorList.forEach((elt) => {
          this.activitySectorItems.push({
            id: elt["@id"],
            name: elt["name"],
          });
        });
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        }
        this.formErrors.push(reason);
        console.error(reason);
      });
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu1(val) {
      val && setTimeout(() => (this.activeOfferExpirationPicker = "YEAR"));
    },
    jobType(value) {
      const offerTypeChoosed = this.jobOfferTypeItems.filter(
        (elt) => elt.id === value
      )[0];
      if (offerTypeChoosed !== undefined) {
        if (offerTypeChoosed.name === "Contrat à durée indéterminée (CDI)") {
          this.displayDurationAndExpiration = false;
          this.formFields.duration = null;
          this.formFields.offerExpirationDate = null;
        } else {
          this.displayDurationAndExpiration = true;
        }
      }
    },
  },
  methods: {
    checkJobValue() {
      if (this.formFields.job === null) {
        this.displayActivitySector = false;
      } else if (typeof this.formFields.job !== "object") {
        this.displayActivitySector = true;
      } else {
        this.displayActivitySector = false;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    save1(date) {
      this.$refs.menu1.save(date);
    },
    checkForm() {
      this.formErrors = [];
      let isValid = true;

      if (!this.jobType || this.jobType.trim() === "") {
        isValid = false;
        this.formErrors.push("Le type d'emploi est obligatoire.");
      } else if (
        this.jobOfferTypeList.filter((elt) => elt["@id"] === this.jobType)
          .length !== 1
      ) {
        isValid = false;
        this.formErrors.push("Le type d'emploi est invalide.");
      }

      if (!this.formFields.job) {
        isValid = false;
        this.formErrors.push("Le poste est obligatoire.");
      } else if (typeof this.formFields.job === "object") {
        if (
          this.jobList.filter((elt) => elt["@id"] === this.formFields.job.id)
            .length !== 1
        ) {
          isValid = false;
          this.formErrors.push("Le poste est invalide.");
        }
      } else {
        // check for the validity of activity sector
        if (
          !this.formFields.activitySector ||
          this.formFields.activitySector.trim() === ""
        ) {
          isValid = false;
          this.formErrors.push("Le secteur d'activité est obligatoire.");
        } else if (
          this.activitySectorList.filter(
            (elt) => elt["@id"] === this.formFields.activitySector
          ).length !== 1
        ) {
          isValid = false;
          this.formErrors.push("Le secteur d'activité est invalide.");
        }
      }

      if (
        !this.formFields.jobLocation ||
        this.formFields.jobLocation.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Le lieu de travail est obligatoire.");
      }

      // if (
      //   !this.formFields.remuneration ||
      //   this.formFields.remuneration.trim() === ""
      // ) {
      //   isValid = false;
      //   this.formErrors.push("La rémunération est obligatoire.");
      // }

      // if (
      //   !this.formFields.startDate ||
      //   this.formFields.startDate.trim() === ""
      // ) {
      //   isValid = false;
      //   this.formErrors.push("La date de démarrage est obligatoire.");
      // }

      if (
        !this.formFields.description ||
        this.formFields.description.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("La description est obligatoire.");
      }

      return isValid;
    },

    editJobOffer() {
      if (this.checkForm()) {
        const httpClient = new HttpClient();
        const user = JSON.parse(localStorage.getItem("currentUser"));
        if (typeof this.formFields.job === "object") {
          const jobOffer = {
            type: this.jobType,
            job: this.formFields.job.id,
            jobLocation: this.formFields.jobLocation,
            coverLetter: this.formFields.coverLetterIsRequired,
            description: this.formFields.description,
            duration: this.formFields.duration,
            offerExpirationTime: this.formFields.offerExpirationDate,
          };

          if (
            this.formFields.remuneration &&
            this.formFields.remuneration.trim() !== ""
          ) {
            jobOffer.remuneration = this.formFields.remuneration;
          }

          if (
            this.formFields.startDate &&
            this.formFields.startDate.trim() !== ""
          ) {
            jobOffer.startDate = this.formFields.startDate;
          }

          httpClient
            .putFromApiPlatformUri(
              "/api/job_offers/" + this.currentJobOffer.id,
              jobOffer,
              localStorage.getItem("jwt-token")
            )
            .then((value) => {
              this.$router.push("/company/offers?updated");
            })
            .catch((reason) => {
              if (reason.response.status === 401) {
                this.$router.push("/logout");
              } else {
                this.snackbarFailed = true;
                this.snackbarFailedMessage =
                  reason.response.data["hydra:description"];
              }
              this.formErrors = [];
              this.formErrors.push("Une erreur s'est produite");
            });
        } else {
          // first off create new job offer type
          httpClient
            .postFromApiPlatformUri(
              "/api/jobs",
              {
                name: this.formFields.job,
                activitySector: this.formFields.activitySector,
              },
              localStorage.getItem("jwt-token")
            )
            .then((value) => {
              //then create job offer

              const jobOffer = {
                type: this.jobType,
                job: value.data["@id"],
                jobLocation: this.formFields.jobLocation,
                coverLetter: this.formFields.coverLetterIsRequired,
                description: this.formFields.description,
                duration: this.formFields.duration,
                offerExpirationTime: this.formFields.offerExpirationDate,
              };

              if (
                this.formFields.remuneration &&
                this.formFields.remuneration.trim() !== ""
              ) {
                jobOffer.remuneration = this.formFields.remuneration;
              }

              if (
                this.formFields.startDate &&
                this.formFields.startDate.trim() !== ""
              ) {
                jobOffer.startDate = this.formFields.startDate;
              }

              httpClient
                .putFromApiPlatformUri(
                  "/api/job_offers/" + this.currentJobOffer.id,
                  jobOffer,
                  localStorage.getItem("jwt-token")
                )
                .then((value) => {
                  this.$router.push("/company/offers?updated");
                })
                .catch((reason) => {
                  if (reason.response.status === 401) {
                    this.$router.push("/logout");
                  } else {
                    this.snackbarFailed = true;
                    this.snackbarFailedMessage =
                      reason.response.data["hydra:description"];
                  }
                  this.formErrors = [];
                  this.formErrors.push("Une erreur s'est produite");
                });
            })
            .catch((reason) => {
              if (reason.response.status === 401) {
                this.$router.push("/logout");
              } else {
                this.snackbarFailed = true;
                this.snackbarFailedMessage =
                  reason.response.data["hydra:description"];
              }
              this.formErrors = [];
              this.formErrors.push("Une erreur s'est produite");
            });
        }
      }
    },
  },
});
</script>

<style scoped></style>
